import script from "./SocietalChallengeAndOrganizationalSolutionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SocietalChallengeAndOrganizationalSolutionView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__